import {
  deloitteStandardELSOWTemplateReferredGroupOptions,
  gbtOptions,
  generalBusinessTermsGroupOptions,
  groupToolTipOptions,
  multiSelectOptions,
  opportunityComplexityOptionsOriginal,
  options,
  productAndToolsOptionsOriginal,
  radioBtnsForSubContractor,
  radioBtnsForTermsAndConditionsGovernService,
  radioBtnsOriginal,
  radioGroupOptions,
  radioGroupOptionsForUSmemberFirmRole,
  selectOptions,
  sensitiveDataOptionsOriginal,
  textareaOptions,
  useOfExistingMSAsOrContractMakerGBTsGroupOptions,
} from './complexity-questions-setting';
import { SubmissionService } from './../../../http/intake/submission.service';
import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MultiSelectItem } from '@usitsdasdesign/dds-ng/multi-select';
import { Size, Themes } from '@usitsdasdesign/dds-ng/shared';
import { RadioButton } from '@usitsdasdesign/dds-ng/radio';
import { OpportunityDetailsNavModel } from '../../../common/models/opportunity-details.model';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { IAutosaverOptions, Saver } from '../../../common/autosaver/saver';
import { AutosaverService } from '../../../common/autosaver/autosaver.service';
import { IntakeConstant } from '../../constants/intake.constant';
import { complexityQuestionsData } from '../../../common/models/complexity-question-data.model';
import { commonSectionForSingleCoCheck } from '../../common/intake.util';
import {
  configurationType,
  PermissionsObj,
} from '../../../common/models/common-models';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-complexity-questions',
  templateUrl: './complexity-questions.component.html',
  styleUrl: './complexity-questions.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplexityQuestionsComponent
  implements OnInit, OnChanges, OnDestroy
{
  model: complexityQuestionsData = {} as complexityQuestionsData;
  @Input() submissionData: OpportunityDetailsNavModel[] = [];
  @Input() OpportunityID: string | null = '';
  @Input() permissionObj: PermissionsObj = {} as PermissionsObj;
  @Input() configLabels: configurationType[] = [];
  saveComplexityModule!: Saver | null;
  complexityForm!: FormGroup;
  #destroy$: Subject<any> = new Subject<any>();
  opportunityComplexityOptions: MultiSelectItem[] = [];
  productAndToolsOptions: MultiSelectItem[] = [];
  sensitiveDataOptions: MultiSelectItem[] = [];
  radioBtns: RadioButton[] = [];
  radioBtnForUsMemberFirmRole: RadioButton[] = radioBtnsForSubContractor;
  radioGroupOptionsForUSmemberFirmRole = radioGroupOptionsForUSmemberFirmRole;
  gbtOptions = gbtOptions;
  maxSizeMemberFirms = IntakeConstant.TEXTAREA_CHAR_LIMIT;
  opportunityComplexityOptionsOriginal = opportunityComplexityOptionsOriginal;
  productAndToolsOptionsOriginal = productAndToolsOptionsOriginal;
  sensitiveDataOptionsOriginal = sensitiveDataOptionsOriginal;
  multiSelectOptions = multiSelectOptions;
  selectOptions = selectOptions;
  options = options;
  dataFromJupiter: complexityQuestionsData = {} as complexityQuestionsData;
  groupToolTipOptions = groupToolTipOptions;
  radioGroupOptions = radioGroupOptions;
  textareaOptions = textareaOptions;
  deloitteStandardELSOWTemplateReferredGroupOptions =
    deloitteStandardELSOWTemplateReferredGroupOptions;
  useOfExistingMSAsOrContractMakerGBTsGroupOptions =
    useOfExistingMSAsOrContractMakerGBTsGroupOptions;
  generalBusinessTermsGroupOptions = generalBusinessTermsGroupOptions;
  radioBtnsOriginal = radioBtnsOriginal;
  htmlElementSize: Size = IntakeConstant.UI_ELEMENT_SIZE;
  yesValue: string = IntakeConstant.YES;
  tprmNoteWords: string[] = [];
  tprmText: string = IntakeConstant.TPRM_TEXT;
  ifaNote: string = IntakeConstant.COMPLEX_QUESTION_IFA_NOTE;
  ifaLink: string = IntakeConstant.COMPLEX_QUESTION_IFA_HYPERLINK;
  ifaText: string = IntakeConstant.IFA_TEXT;
  subcontractorNote: string =
    IntakeConstant.COMPLEX_QUESTION_NOTES_SUBCONTRACTOR;
  updatedIfaNote: string = '';
  termsAndConditionsRadioBtns: RadioButton[] =
    radioBtnsForTermsAndConditionsGovernService;

  constructor(
    private readonly fb: FormBuilder,
    private readonly autosaverService: AutosaverService,
    private readonly submissionService: SubmissionService
  ) {}

  ngOnInit(): void {
    this.addAnchorTag();
    this.initializeForm();
    this.updateOptions();
    this.emitFormData();
    this.getComplexityResponseFromJupiter(this.OpportunityID)
      .then(() => {
        this.getExistingFormData(this.OpportunityID)
          .then(() => {
            this.initiateAutoSave();
          })
          .catch((error) => {
            console.error('Error fetching existing form data:', error);
          });
      })
      .catch((error) => {
        console.error('Error fetching existing form data:', error);
      });
    this.submissionService.updateComplexQuestionStatus(
      this.complexityForm.valid
    );
  }

  initiateAutoSave(): void {
    let autoSaverOptions = {
      onSuccess: (saver: any, result: complexityQuestionsData) => {
        return this.autoSaveHandler();
      },
    } as IAutosaverOptions;

    this.saveComplexityModule = this.autosaverService.newSaver(
      'model',
      this,
      (model) => this.saveDetails(model),
      autoSaverOptions
    );

    this.saveComplexityModule.start();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['submissionData'] &&
      !changes['submissionData'].isFirstChange()
    ) {
      this.updateOptions();
    }

    if (changes['configLabels']) {
      this.mapCongiguration();
    }

    if (changes['permissionObj'] && this.complexityForm) {
      this.isFormDisabled();
    }
  }

  ngOnDestroy(): void {
    this.#destroy$.next('');
    this.#destroy$.complete();
  }
  autoSaveHandler(): void {
    //if refresh is needed after save API, can be done here;
  }

  initializeForm(): void {
    this.complexityForm = this.fb.group({
      opportunityComplexity: [[], Validators.required],
      regulatoryConsiderations: ['', []],
      productAndTools: [[], Validators.required],
      thirdPartyInvolvement: ['', Validators.required],
      memberFirmInvolvement: ['', Validators.required],
      memberFirmNames: ['', []],
      sensitiveData: [[], Validators.required],
      dataInDeloittesOrDeloittesHostedEnvironment: ['', Validators.required],
      usfirmrole: [''],
      deloitteStandardELSOWTemplateReferred: ['', Validators.required],
      useOfExistingMSAsOrContractMakerGBTs: ['', Validators.required],
      generalBusinessTerms: ['', []],
    });

    this.isFormDisabled();

    this.complexityForm
      .get('opportunityComplexity')
      ?.valueChanges.pipe(takeUntil(this.#destroy$))
      .subscribe((selected) => {
        const hasRegulatory = selected.some(
          (item: MultiSelectItem) =>
            item.label === IntakeConstant.REGULATORY_CONSIDERATION
        );
        const regulatoryControl = this.complexityForm.get(
          'regulatoryConsiderations'
        );
        if (hasRegulatory) {
          regulatoryControl?.setValidators([Validators.required]);
        } else {
          regulatoryControl?.clearValidators();
          regulatoryControl?.setValue('');
        }
        regulatoryControl?.updateValueAndValidity();
      });

    this.complexityForm
      .get('memberFirmInvolvement')
      ?.valueChanges.pipe(takeUntil(this.#destroy$))
      .subscribe((value) => {
        const memberFirmNamesControl =
          this.complexityForm.get('memberFirmNames');
          this.complexityForm.get('usfirmrole');
        if (value === IntakeConstant.YES) {
          memberFirmNamesControl?.setValidators([Validators.required]);
          this.complexityForm.get('usfirmrole')?.setValidators([Validators.required]);
        } else {
          memberFirmNamesControl?.clearValidators();
          memberFirmNamesControl?.setValue('');
          this.complexityForm.get('usfirmrole')?.clearValidators();
          this.complexityForm.get('usfirmrole')?.setValue('');
        }
        memberFirmNamesControl?.updateValueAndValidity();
      });

    this.complexityForm.valueChanges
      .pipe(takeUntil(this.#destroy$))
      .subscribe(() => {
        this.submissionService.updateComplexQuestionStatus(
          this.complexityForm.valid
        );
      });

    this.complexityForm.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
        ),
        takeUntil(this.#destroy$)
      )
      .subscribe((value) => {
        this.emitFormData();
        this.saveComplexityModule?.saveNow();
      });
  }

  isFormDisabled(): void {
    if (this.permissionObj['Intake_Opportunity_Complexity_Enable']) {
      this.complexityForm?.enable();
      this.options.disabled = false;
    } else {
      this.complexityForm?.disable();
      this.options.disabled = true;
    }
  }

  updateOptions(): void {
    const includeNotYetDetermined = this.shouldIncludeNotYetDetermined();
    this.opportunityComplexityOptions = [
      ...this.opportunityComplexityOptionsOriginal,
    ];
    if (includeNotYetDetermined) {
      this.opportunityComplexityOptions.push({
        label: IntakeConstant.NOT_YET_DETERMINED,
      });
    }
    this.productAndToolsOptions = [...this.productAndToolsOptionsOriginal];
    if (includeNotYetDetermined) {
      this.productAndToolsOptions.push({
        label: IntakeConstant.NOT_YET_DETERMINED,
      });
    }
    this.sensitiveDataOptions = [...this.sensitiveDataOptionsOriginal];
    if (includeNotYetDetermined) {
      this.sensitiveDataOptions.push({
        label: IntakeConstant.NOT_YET_DETERMINED,
      });
    }
    this.radioBtns = [...this.radioBtnsOriginal];
    if (includeNotYetDetermined) {
      this.radioBtns.push({
        options: {
          label: IntakeConstant.NOT_YET_DETERMINED,
          theme: Themes.green,
        },
        value: IntakeConstant.NOT_YET_DETERMINED,
      });
    }
  }

  shouldIncludeNotYetDetermined(): boolean {
    if (!this.submissionData || this.submissionData.length === 0) {
      return false;
    }
    const validSubmissions = this.submissionData.filter(
      (submission) =>
        submission.submissionStatusName !== IntakeConstant.DISCONTINUED &&
        submission.submissionStatusName !== IntakeConstant.PURGED
    );

    const hasOnlyProposal = validSubmissions.every(
      (submission) => submission.submissionTypeCode === IntakeConstant.PROPOSAL
    );

    const hasOtherValidSubmission = validSubmissions.some(
      (submission) => submission.submissionTypeCode !== IntakeConstant.PROPOSAL
    );

    if (hasOtherValidSubmission) {
      return false;
    }
    return hasOnlyProposal;
  }

  get hasRegulatoryConditions(): boolean {
    const selected = this.complexityForm.get('opportunityComplexity')?.value;
    return (
      selected?.some(
        (item: MultiSelectItem) =>
          item.label === IntakeConstant.REGULATORY_CONSIDERATION
      ) || false
    );
  }

  emitFormData(): void {
    const formData = this.complexityForm.value;
    const transformedData: complexityQuestionsData = {
      opportunityNumber: this.OpportunityID,
      opportunityComplexity:
        formData.opportunityComplexity
          ?.filter((item: MultiSelectItem) => item.value)
          .map((item: MultiSelectItem) => item.label)
          .join(';') || null,
      productsAndTools:
        formData.productAndTools
          ?.filter((item: MultiSelectItem) => item.value)
          .map((item: MultiSelectItem) => item.label)
          .join(';') || null,
      sensitiveData:
        formData.sensitiveData
          ?.filter((item: MultiSelectItem) => item.value)
          .map((item: MultiSelectItem) => item.label)
          .join(';') || null,
      regulatoryConsiderations: formData.regulatoryConsiderations || null,
      thirdPartyInvolvement: formData.thirdPartyInvolvement || null,
      memberFirmInvolvement: formData.memberFirmInvolvement || null,
      memberFirmNames: formData.memberFirmNames || null,
      dataInDeloittesOrDeloittesHostedEnvironment:
        formData.dataInDeloittesOrDeloittesHostedEnvironment || null,
      usFirmRole: formData.usfirmrole || null,
      deloitteStandardELSOWTemplateReferred:
        formData.deloitteStandardELSOWTemplateReferred || null,
      useOfExistingMSAsOrContractMakerGBTs:
        formData.useOfExistingMSAsOrContractMakerGBTs || null,
    };
    this.model = transformedData;
  }

  saveDetails(model: complexityQuestionsData) {
    if (this.permissionObj['Intake_Opportunity_Complexity_Enable']) {
      return this.submissionService.saveComplexitydata(model).toPromise();
    }
    return Promise.resolve();
  }

  getExistingFormData(opportunityID: string | null): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (opportunityID) {
        this.submissionService
          .getComplexityResponse(opportunityID)
          .pipe(takeUntil(this.#destroy$))
          .subscribe({
            next: (data: complexityQuestionsData) => {
              this.model = data;
              this.patchFormWithData(data, this.dataFromJupiter);
              resolve();
            },
            error: (err: HttpErrorResponse) => {
              console.error('Error fetching the data', err);
              reject();
            },
          });
      } else {
        resolve();
      }
    });
  }

  getComplexityResponseFromJupiter(
    opportunityID: string | null
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.submissionService
        .getComplexityResponseFromJupiter(opportunityID)
        .pipe(takeUntil(this.#destroy$))
        .subscribe({
          next: (data: complexityQuestionsData) => {
            this.dataFromJupiter = data;
            resolve();
          },
          error: (err: HttpErrorResponse) => {
            console.error('Error fetching the data', err);
            reject();
          },
        });
    });
  }

  patchFormWithData(
    data: complexityQuestionsData,
    dataFromJupiter: complexityQuestionsData
  ): void {
    const createMultiSelectItems = (
      dataString: string | null | undefined
    ): MultiSelectItem[] => {
      if (!dataString) return [];
      return dataString
        .split(';')
        .filter((label) => label.trim().length > 0)
        .map((label) => ({
          label: label.trim(),
          value: true,
        }));
    };
    const opportunityComplexityItems = data?.opportunityComplexity
      ? createMultiSelectItems(data?.opportunityComplexity)
      : createMultiSelectItems(dataFromJupiter?.opportunityComplexity);
    const productAndToolsItems = createMultiSelectItems(data?.productsAndTools);
    const sensitiveDataItems = data?.sensitiveData
      ? createMultiSelectItems(data?.sensitiveData)
      : createMultiSelectItems(dataFromJupiter?.sensitiveData);

    const shouldResetOpportunityComplexity = opportunityComplexityItems.some(
      (item) => item.label === IntakeConstant.NOT_YET_DETERMINED
    );
    const shouldResetProductAndTools = productAndToolsItems.some(
      (item) => item.label === IntakeConstant.NOT_YET_DETERMINED
    );
    const shouldResetSensitiveData = sensitiveDataItems.some(
      (item) => item.label === IntakeConstant.NOT_YET_DETERMINED
    );

    const finalOpportunityComplexity =
      shouldResetOpportunityComplexity &&
      this.shouldIncludeNotYetDetermined() === false
        ? []
        : opportunityComplexityItems;

    const finalProductAndTools =
      shouldResetProductAndTools &&
      this.shouldIncludeNotYetDetermined() === false
        ? []
        : productAndToolsItems;
    const finalSensitiveData =
      shouldResetSensitiveData && this.shouldIncludeNotYetDetermined() === false
        ? []
        : sensitiveDataItems;

    if (
      shouldResetOpportunityComplexity &&
      this.shouldIncludeNotYetDetermined() === false
    ) {
      data.regulatoryConsiderations = '';
    }

    let thirdPartyInvolvement = data?.thirdPartyInvolvement || null;
    const shouldResetThirdPartyInvolvement =
      thirdPartyInvolvement === IntakeConstant.NOT_YET_DETERMINED ||
      thirdPartyInvolvement === IntakeConstant.YES_TEAMING;
    if (
      shouldResetThirdPartyInvolvement &&
      this.shouldIncludeNotYetDetermined() === false
    ) {
      thirdPartyInvolvement = '';
    }

    let memberFirmInvolvement =
      (data?.memberFirmInvolvement
        ? data?.memberFirmInvolvement
        : dataFromJupiter.memberFirmInvolvement) || null;
    const shouldResetMemberFirmInvolvement =
      memberFirmInvolvement === IntakeConstant.NOT_YET_DETERMINED;
    if (
      shouldResetMemberFirmInvolvement &&
      this.shouldIncludeNotYetDetermined() === false
    ) {
      memberFirmInvolvement = '';
      data.memberFirmNames = '';
    }

    let dataInDeloittesOrDeloittesHostedEnvironment =
      data?.dataInDeloittesOrDeloittesHostedEnvironment || null;
    const shouldResetDataInDeloittesOrDeloittesHostedEnvironment =
      dataInDeloittesOrDeloittesHostedEnvironment ===
      IntakeConstant.NOT_YET_DETERMINED;
    if (
      shouldResetDataInDeloittesOrDeloittesHostedEnvironment &&
      this.shouldIncludeNotYetDetermined() === false
    ) {
      dataInDeloittesOrDeloittesHostedEnvironment = '';
    }

    let deloitteStandardELSOWTemplateReferred =
      data?.deloitteStandardELSOWTemplateReferred || null;
    const shouldResetDeloitteStandardELSOWTemplateReferred =
      deloitteStandardELSOWTemplateReferred ===
      IntakeConstant.NOT_YET_DETERMINED;
    if (
      shouldResetDeloitteStandardELSOWTemplateReferred &&
      this.shouldIncludeNotYetDetermined() === false
    ) {
      deloitteStandardELSOWTemplateReferred = '';
    }

    let useOfExistingMSAsOrContractMakerGBTs =
      data?.useOfExistingMSAsOrContractMakerGBTs || null;

    this.complexityForm.patchValue({
      opportunityComplexity: finalOpportunityComplexity,
      productAndTools: finalProductAndTools,
      sensitiveData: finalSensitiveData,
      regulatoryConsiderations: data?.regulatoryConsiderations || '',
      thirdPartyInvolvement: thirdPartyInvolvement,
      memberFirmInvolvement: memberFirmInvolvement,
      memberFirmNames: data?.memberFirmNames
        ? data?.memberFirmNames
        : dataFromJupiter?.memberFirmNames || '',
      dataInDeloittesOrDeloittesHostedEnvironment:
        dataInDeloittesOrDeloittesHostedEnvironment,
      usfirmrole: data?.usFirmRole || null,
      deloitteStandardELSOWTemplateReferred:
        deloitteStandardELSOWTemplateReferred,
      useOfExistingMSAsOrContractMakerGBTs:
        useOfExistingMSAsOrContractMakerGBTs,
      generalBusinessTerms: data?.generalBusinessTerms || '',
    });

    this.emitFormData();

    ['opportunityComplexity', 'productAndTools', 'sensitiveData'].forEach(
      (item) => this.valueChanged(this.complexityForm.get(item)?.value, item)
    );
  }

  removeOpportunityComplexity(item: MultiSelectItem): void {
    if (this.permissionObj['Intake_Opportunity_Complexity_Enable']) {
      const current = this.complexityForm.get('opportunityComplexity')
        ?.value as MultiSelectItem[];
      const updated = current.filter((i) => i !== item);
      this.valueChanged(updated, 'opportunityComplexity');
    }
  }

  removeProductAndTools(item: MultiSelectItem): void {
    if (this.permissionObj['Intake_Opportunity_Complexity_Enable']) {
      const current = this.complexityForm.get('productAndTools')
        ?.value as MultiSelectItem[];
      const updated = current.filter((i) => i !== item);
      this.valueChanged(updated, 'productAndTools');
    }
  }

  removeSensitiveData(item: MultiSelectItem): void {
    if (this.permissionObj['Intake_Opportunity_Complexity_Enable']) {
      const current = this.complexityForm.get('sensitiveData')
        ?.value as MultiSelectItem[];
      const updated = current.filter((i) => i !== item);
      this.valueChanged(updated, 'sensitiveData');
    }
  }

  isOpportunityComplexityRequired(): boolean {
    if (commonSectionForSingleCoCheck(this.submissionData)) {
      return false;
    } else if (
      this.complexityForm.get('opportunityComplexity')?.invalid ||
      (this.hasRegulatoryConditions &&
        this.complexityForm.get('regulatoryConsiderations')?.invalid)
    ) {
      return true;
    } else {
      return false;
    }
  }

  isFieldRequired(control: AbstractControl | null): boolean {
    if (commonSectionForSingleCoCheck(this.submissionData)) {
      return false;
    } else if (control != null && control?.invalid) {
      return true;
    } else {
      return false;
    }
  }

  isMemberFirmInvolvementRequired(): boolean {
    if (commonSectionForSingleCoCheck(this.submissionData)) {
      return false;
    } else if (
      this.complexityForm.get('memberFirmInvolvement')?.invalid ||
      (this.complexityForm.get('memberFirmInvolvement')?.value ===
        IntakeConstant.YES &&
        this.complexityForm.get('memberFirmNames')?.invalid)
    ) {
      return true;
    } else {
      return false;
    }
  }

  isUseOfExistingMSAsOrContractMakerGBTsRequired(): boolean {
    if (commonSectionForSingleCoCheck(this.submissionData)) {
      return false;
    } else if (
      this.complexityForm.get('useOfExistingMSAsOrContractMakerGBTs')?.invalid
    ) {
      return true;
    } else {
      return false;
    }
  }

  valueChanged(event: MultiSelectItem[], formName: string): void {
    const optionsName: string = `${formName}Options`;

    const noneOptionSelected: boolean = event.some(
      (item: MultiSelectItem) =>
        item.label === IntakeConstant.NONE && item.value
    );
    const notYetOptionSelected: boolean = event.some(
      (item: MultiSelectItem) =>
        item.label === IntakeConstant.NOT_YET_DETERMINED && item.value
    );

    if (noneOptionSelected || notYetOptionSelected) {
      (this as unknown as { [key: string]: MultiSelectItem[] })[
        optionsName
      ]?.forEach((item: MultiSelectItem) => {
        if (item.label === IntakeConstant.NONE && noneOptionSelected) {
          item.disabled = false;
        } else if (
          item.label === IntakeConstant.NOT_YET_DETERMINED &&
          notYetOptionSelected
        ) {
          item.disabled = false;
        } else {
          item.disabled = true;
          item.value = false;
        }
      });
    } else {
      (this as unknown as { [key: string]: MultiSelectItem[] })[
        optionsName
      ]?.forEach((item: MultiSelectItem) => {
        item.disabled = false;
        item.value = event.some(
          (selected: MultiSelectItem) => selected.label === item.label
        );
      });
    }

    this.complexityForm
      .get(formName)
      ?.setValue(
        (this as unknown as { [key: string]: MultiSelectItem[] })[
          optionsName
        ]?.filter((item) => item.value) ?? []
      );
  }

  mapCongiguration(): void {
    this.tprmNoteWords =
      this.configLabels
        .find(
          (item) =>
            item.appConfigurationLabelKey ===
            'COMPLEXITY_3RDPARTY_INVOLVEMENT_HELPERTEXT'
        )
        ?.appConfigurationLabelValue.split(' ') || [];
  }

  addAnchorTag(): void {
    const anchorTag = `<a href="${this.ifaLink}" class="text-green-2" target="_blank" title="${this.ifaLink}">${this.ifaText}</a>`;
    this.updatedIfaNote = this.ifaNote.replace(this.ifaText, anchorTag);
  }
}
